/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/**
 * Send performance metrics to sentry
 *
 * @param {object} - performance
 *    * metricName {string} - custom performance metric name: i.e home-banner-mount
 *    * value {number} - The value is ms
 */
function sendSentryPerf({ metricName, value }) {
  const sdk = window.adobe_dc_sdk;

  if (!("Sentry" in sdk)) {
    return;
  }

  const transaction = sdk.Sentry.getCurrentHub()
    .getScope()
    .getTransaction();
  if (transaction) {
    transaction.setMeasurement(metricName, Math.round(value), "millisecond");
  }
}

// eslint-disable-next-line import/prefer-default-export
export { sendSentryPerf };
